<template>
  <div class="accreditation-details-row">
    <div class="accreditation-details-row-content">
      <span class="accreditation-details-row-label">{{ workflowLabel(label) }}</span>
      <strong class="accreditation-details-row-value"><slot>{{ workflowLabel(value || '-') }}</slot></strong>
    </div>
    <slot name="action" />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'accreditation-details-row',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      default: '',
    },
  },
}
</script>

<style scoped>
.accreditation-details-row,
.accreditation-details-row-content {
  align-items: center;
  display: flex;
  gap: 16px;
}

.accreditation-details-row {
  border-bottom: 1px solid #d9d9d9;
  justify-content: space-between;
  min-height: 48px;
}

.accreditation-details-row:last-child {
  border-bottom: 0;
}

.accreditation-details-row-content {
  min-width: 0;
}

.accreditation-details-row-label {
  color: #665f5c;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  flex: 0 0 112px;
}

.accreditation-details-row-value {
  color: #666666;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 18px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 800px) {
  .accreditation-details-row,
  .accreditation-details-row-content {
    align-items: stretch;
    flex-direction: column;
  }

  .accreditation-details-row {
    padding: 8px 0;
  }

  .accreditation-details-row-label {
    flex-basis: auto;
  }
}
</style>
